export type DepositTransferType =
  (typeof DEPOSIT_TRANSFER_TYPE)[keyof typeof DEPOSIT_TRANSFER_TYPE];

export const DEPOSIT_TRANSFER_TYPE = {
  EFT: 'EFT',
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
  EXTERNAL_TRANSFER: 'EXTERNAL_TRANSFER',
} as const;
